<template>
  <div class="task-overdue-from p-mb-4">
    <div class="p-field">
      <label for="taskOverdueFrom">Tasks count as overdue from</label>
      <div class="p-d-flex p-ai-center">
        <Calendar id="taskOverdueFrom" v-model="date" dateFormat="dd/mm/yy" :showIcon="true" :showButtonBar="true"
                  :disabled="loading || !!loadError" class="p-mr-2" />
        <Button v-if="!loadError" data-test="save-task-overdue-from" label="Save" icon="pi pi-check"
                :disabled="loading || saving || !dirty" @click="save" />
      </div>
      <small class="hint">{{ hint }}</small>
      <small class="p-invalid" v-if="loadError">{{ loadError }}</small>
    </div>
  </div>
</template>

<script>
import AppSettingsService from '@/service/AppSettingsService'
import { toIsoDate, fromIsoDate } from '@/mbp/followupSetting/bankHolidays/bankHolidayDates'
import { HINT } from './overdueFromHint'

function messageOf(err, fallback) {
  var data = err && err.response && err.response.data
  if (data && typeof data.error === 'string' && data.error) return data.error
  return fallback
}

export default {
  name: 'TaskOverdueFrom',
  data: () => ({
    appSettingsService: new AppSettingsService(),
    hint: HINT,
    date: null,
    saved: null,
    loading: true,
    saving: false,
    loadError: null
  }),
  computed: {
    dirty() {
      return toIsoDate(this.date) !== this.saved
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      return this.appSettingsService.getTaskOverdueFrom()
        .then(data => {
          this.saved = (data && data.taskOverdueFrom) || null
          this.date = fromIsoDate(this.saved)
          this.loadError = null
        })
        .catch(err => {
          this.loadError = messageOf(err, 'The overdue start date could not be loaded.')
        })
        .finally(() => { this.loading = false })
    },
    save() {
      this.saving = true
      return this.appSettingsService.saveTaskOverdueFrom(toIsoDate(this.date))
        .then(data => {
          this.saved = (data && data.taskOverdueFrom) || null
          this.date = fromIsoDate(this.saved)
          this.$toast.add({ severity: 'success', summary: 'Saved', detail: 'Tasks count as overdue from was saved.', life: 5000 })
        })
        .catch(err => {
          this.$toast.add({ severity: 'error', summary: 'Not saved', detail: messageOf(err, 'The overdue start date could not be saved.'), life: 5000 })
        })
        .finally(() => { this.saving = false })
    }
  }
}
</script>

<style>
.task-overdue-from .hint { display: block; color: #6c757d; margin-top: 0.25rem; }
.task-overdue-from small.p-invalid { display: block; color: #d32f2f; }
</style>
